import { sizes, spacer, media, colors, fontSize } from 'settings/style';
import styled from 'styled-components';

/**
 * Main site header: padding 10+10 + row min-height 50 + border ≈ 71px.
 * Keeps account tabs stuck directly under the navbar while scrolling.
 */
const accountTabsStickyTop = '72px';

export const StyledWrapper = styled.div`
  display: flex;
  padding: ${spacer.lg} ${spacer.xl} ${spacer.xl};

  ${media.lg`
    padding: ${spacer.md};
  `}
`;

export const StyledTabsWrap = styled.div`
  display: block;
  margin: ${spacer.lg} 0;
  padding-bottom: 0;
  position: sticky;
  top: ${accountTabsStickyTop};
  z-index: 998;
  background: ${colors.white};
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.06);

  ${media.md`
    /* Slightly shorter top bar on small screens (logo-only row) */
    top: 64px;
  `}

  .ant-tabs-nav {
    margin: 0;
  }

  .ant-tabs-tab {
    color: ${colors.gray1300};
    font-size: ${fontSize.base};
    letter-spacing: 0.05em;
    text-transform: uppercase;
    padding: 8px 0;
    ${media.md`
      font-size: ${fontSize.sm};
    `}
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin-left: ${spacer.md};
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${colors.grey900};
  }

  .ant-tabs-tab-btn:focus,
  .ant-tabs-tab-btn:active,
  .ant-tabs-tab:hover {
    color: ${colors.grey900};
  }

  .ant-tabs-ink-bar {
    background: ${colors.accent};
    height: 2px !important;
  }

  .ant-tabs-content-holder {
    display: none;
  }

  ${media.lg`

    .ant-tabs-nav-wrap {
      overflow-x: auto;
    }

    .ant-tabs-nav-list {
      flex-wrap: nowrap;
    }
  `}
`;

export const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: ${sizes.xxl};
  margin: 0 auto;
`;

export const GroupsPage = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  align-self: stretch;
  box-sizing: border-box;

  ${media.lg`
    margin-left: 0;
    margin-right: 0;
    padding: ${spacer.md};
  `}
`;